// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

// | Vendors ----------------------------------------------------------------

// Bootstrap
import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.
import {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  OffCanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
} from "bootstrap";

//import LazyLoad from "vanilla-lazyload"
//import { OverlayScrollbars } from 'overlayscrollbars'; // Used on product filters

import Splide from "@splidejs/splide"; //? https://splidejs.com/
import GLightbox from "glightbox/dist/js/glightbox.js";

import AOS from "aos"; //? https://github.com/michalsnik/aos

// | Template Components ----------------------------------------------------

// Cookies
//import './components/cookieConsent/cookieOptions';

import "./components/cookiePopup";

// Navigation
import "./components/mainNavigation";
//import "./components/dropdownOnHover";

// Header
import "./components/fixedHeader";

// Images
import "./components/imageLazyLoad";
import "./components/modernizr-webp";

// | Page Specific ----------------------------------------------------------

import "./components/caseHistoriesGrid";

window.addEventListener("load", (event) => {
  AOS.init();
});

document.addEventListener("DOMContentLoaded", function () {
  var homeCarousel = document.querySelector(".home-carousel");

  if (homeCarousel) {
    var homeCarousel = new Splide(".home-carousel", {
      type: "fade",
      autoplay: true,
      rewind: true,
      pagination: false,
      arrows: false,
      cover: true,
    }).mount();
  }

  // Light box
  const lightbox = GLightbox({
    selector: ".imageLink",
    touchNavigation: true,
    loop: true,
  });
});

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------

function parallaxBlur() {
  var parallaxElement = document.querySelector(".parallax-bg");

  if (parallaxElement) {
    var elementHeight = parallaxElement.offsetHeight;

    var scrollPos = window.pageYOffset;
    var transformValue = scrollPos / 40;
    var opacityValue = 1 - scrollPos / 1000;
    var blurValue = Math.min(scrollPos / 100, 3);

    if (scrollPos < elementHeight) {
      Object.assign(parallaxElement.style, {
        transform: "translate3d(0," + transformValue + "%, 0)",
        opacity: "" + opacityValue + "",
        filter: "grayscale(100%) brightness(.6) blur(" + blurValue + "px)",
      });
    }
  }
}

window.addEventListener("scroll", parallaxBlur, false);

// | ------------------------------------------------------------------------
// | Debugging
// | ------------------------------------------------------------------------

// import "./debugging/cls";
